// theme constant
export const gridSpacing = 3;
export const drawerWidth = 260;
export const appDrawerWidth = 320;
// Sidebar resize range. No minimum was specified by the user — 200px is chosen as a floor that
// still fits the 30px icon box plus padding without the row content wrapping/overlapping; the
// max (1.5x default) was specified directly.
export const SIDEBAR_MIN_WIDTH = 200;
export const SIDEBAR_MAX_WIDTH = Math.round(drawerWidth * 1.5);
